export default "__VITE_ASSET__nKknL0____"